module.exports = __webpack_public_path__ + "img/croix-menu.38eb2b19.svg";